<template>
  <div class="card" :class="{ collapsed: collapsed }">
    <div class="board" @click.stop="toggle()">
      <div class="arrow">
        <svg-icon :width="'8'" :height="'8'" icon="app-icons/arrow-down" />
      </div>
      <svg-icon
        ref="icon"
        fill="#BCBCBC"
        icon="app-icons/board"
        :width="'18'"
        :height="'18'"
      /><span class="name">{{ boardName }}</span>
    </div>
    <div
      v-for="(elemId, ind) in value"
      :key="ind"
      class="row"
      @click="onClickElement(elemId)"
    >
      <span class="name">{{ elemName(elemId) }}</span> -
      <span class="content">{{ elemContent(elemId) }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import emitter from 'tiny-emitter/instance';
import { stripHTML } from '../../../utils.js';
import { EVENT } from '../../../constants.js';
import SvgIcon from '../../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    value: {
      type: Array,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },

  computed: {
    ...mapGetters('project/data/elements', {
      getContainerNode: 'getContainerNode',
      getElement: 'getNode',
    }),
    ...mapGetters('project/data/boards', {
      getBoard: 'getNode',
    }),

    boardName() {
      return this.getBoard(this.id).name;
    },
  },

  methods: {
    ...mapActions('application/modals', ['setComponentPropertiesModal']),
    /**
     * Event handler for clicking an element
     * @param   {Object}  element
     */
    onClickElement(elemId) {
      const elem = this.getElement(elemId);
      const { x, y, width, height, id } = elem;
      const board = this.getContainerNode(id, 'boards', 'elements');
      emitter.emit(EVENT.ZOOMTONODE, {
        node: elem,
        type: 'elements',
        boardId: board.id,
      });
      this.setComponentPropertiesModal({ value: null });
    },

    elemName(elemId) {
      return stripHTML(this.getElement(elemId).title);
    },

    elemContent(elemId) {
      return stripHTML(this.getElement(elemId).content);
    },

    /**
     * Expand or collapse a container
     */
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  display: flex;
  flex-flow: column;
  margin-bottom: 10px;

  &.collapsed .row {
    display: none;
  }
  &.collapsed .board .arrow {
    transform: rotate(-90deg);
  }

  .board {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: 0 0 10px 0;
    .arrow {
      width: 15px;
      height: 30px;
      min-width: 15px;
      min-height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.1s;
      margin: 0 5px 0 0;
    }
    .name {
      margin: 0 0 0 10px;
      color: #fff;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .row {
    border-radius: 3px;
    &:hover {
      outline: 1px solid #db841e;
    }
    transition: outline ease 0.1s;
    outline: 1px solid transparent;
    cursor: pointer;
    padding: 20px;
    background: #252929;
    margin: 0 0 10px 0;
    user-select: none;
    .name {
      color: #fff;
    }
    .content {
      color: #bcbcbc;
    }
  }
}
</style>
